var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoiceInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.514 1.75C16.5401 1.75 15.75 4.10025 15.75 7H17.514C18.3645 7 18.7889 7 19.0523 6.70687C19.3148 6.41287 19.2692 6.02613 19.1782 5.2535C18.935 3.21125 18.2823 1.75 17.514 1.75Z",
    stroke: "#667185",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 7.04725V16.3152C15.75 17.6374 15.75 18.2989 15.3458 18.5596C14.6851 18.9849 13.664 18.0924 13.1504 17.7686C12.726 17.5009 12.5142 17.3679 12.2789 17.36C12.0242 17.3513 11.8081 17.4799 11.3496 17.7686L9.6775 18.823C9.226 19.1074 9.00113 19.25 8.75 19.25C8.49887 19.25 8.27312 19.1074 7.8225 18.823L6.15125 17.7686C5.726 17.5009 5.51425 17.3679 5.27887 17.36C5.02425 17.3513 4.80813 17.4799 4.34963 17.7686C3.836 18.0924 2.81487 18.9849 2.15337 18.5596C1.75 18.2989 1.75 17.6382 1.75 16.3152V7.04725C1.75 4.55 1.75 3.30225 2.51912 2.52613C3.28737 1.75 4.5255 1.75 7 1.75H17.5",
    stroke: "#667185",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 7C7.78312 7 7 7.588 7 8.3125C7 9.037 7.78312 9.625 8.75 9.625C9.71688 9.625 10.5 10.213 10.5 10.9375C10.5 11.662 9.71688 12.25 8.75 12.25M8.75 7C9.51125 7 10.1605 7.36487 10.4002 7.875M8.75 7V6.125M8.75 12.25C7.98875 12.25 7.3395 11.8851 7.09975 11.375M8.75 12.25V13.125",
    stroke: "#667185",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceInactive);
export default __webpack_public_path__ + "static/media/invoice-inactive.fe860ec96b421f1a246ca3c93fd1b1e1.svg";
export { ForwardRef as ReactComponent };